import { Box, Heading } from 'grommet'
import styled from 'styled-components'

export const Wrapper = styled(Box)`
  background-color: ${({ theme }) => theme.newColors.lightGray};
  margin-bottom: ${({ theme }) => theme.spaces[3]}px;
  padding: ${({ theme }) => theme.spaces[4] - theme.spaces[1]}px;

  ${({ theme }) => theme.below.mobileL`
    padding: ${({ theme }) => theme.spaces[3]}px;
  `}
`

export const Title = styled(Heading)`
  ${({ theme }) => theme.getTypography('desktop', 'title', 'title4')}

  color: ${({ theme }) => theme.newColors.accent};
  margin-bottom: ${({ theme }) => theme.spaces[2] + theme.spaces[1]}px;
  text-transform: uppercase;
  width: 100%;

  ${({ theme }) => theme.below.mobileL`
    ${theme.getTypography('mobile', 'title', 'title4')}
  `}
`

export const RequirementsList = styled.ul`
  list-style-type: none;

  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spaces[4]}px;
  }
`

export const RequirementID = styled.span`
  ${({ theme }) => theme.getTypography('desktop', 'title', 'title4')}

  color: ${({ theme }) => theme.newColors.accent};
  min-width: ${({ theme }) => theme.spaces[4] + theme.spaces[3]}px;

  ${({ theme }) => theme.below.mobileM`
    margin-bottom: ${({ theme }) => theme.spaces[2]}px;
  `}
`

export const Requirement = styled.li`
  ${({ theme }) => theme.getTypography('desktop', 'body', 'body3')}

  align-items: flex-start;
  color: ${({ theme }) => theme.newColors.primary};
  display: flex;
  padding: ${({ theme }) => theme.spaces[2]}px 0;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.newColors.grayOnHover};
  }

  ${({ theme }) => theme.below.mobileM`
    ${theme.getTypography('mobile', 'body', 'body3')}

    font-weight: 300;
    flex-wrap: wrap;
  `}
`
